import Vue from "vue"
export const EventBus = new Vue()


// WEBPACK FOOTER //
// ./src/components/mixins/eventBus.js